import { convert12hTo24hTime, getTimeFromUTCCore } from './chunk-67X7HZEW.mjs';

// src/helpers/factories/settings/printerRulesFactory.ts
var PRINTER_RULES_ORDER_TYPE_OPTIONS = [
  "all",
  "dine in" /* DINE_IN */,
  "catering" /* CATERING */,
  "delivery" /* DELIVERY */,
  "to_go" /* TO_GO */
];
var DEFAULT_SERVICE_AREA_OPTIONS = [
  "all" /* ALL */,
  "no_table" /* NO_TABLE */,
  "catering" /* CATERING */,
  "to_go" /* TO_GO */,
  "delivery" /* DELIVERY */
];
var serviceAreasDropdownOptionsFactory = (t, serviceAreas, showAll = true, showOtherOptions = false) => {
  let options = [
    [
      ...Object.entries(serviceAreas).map((serviceArea) => ({
        label: serviceArea[1].name,
        value: Number(serviceArea[1].id)
      }))
    ]
  ];
  if (showAll) {
    options[0].unshift({
      label: t("commonTexts.all"),
      value: 0
    });
  }
  if (showOtherOptions) {
    options = [
      ...options,
      DEFAULT_SERVICE_AREA_OPTIONS.map((option, index) => ({
        label: t(
          `settingsModule.licenseSettings.tableServiceOrderSettings.defaultServiceAreaOptions.${option}`
        ),
        value: (index + 1) * -1
      }))
    ];
  }
  return options;
};
var orderTypeDropdownOptionsFactory = (t, orderTypesAvailable, showAll = true) => {
  const options = [
    {
      label: t("commonTexts.all"),
      value: PRINTER_RULES_ORDER_TYPE_OPTIONS.indexOf("all")
    }
  ];
  if (!showAll)
    options.pop();
  if (orderTypesAvailable.isDineInAvailable) {
    options.push({
      label: t("settingsModule.registerModeSettings.general.orderTypes.dineIn"),
      value: PRINTER_RULES_ORDER_TYPE_OPTIONS.indexOf("dine in" /* DINE_IN */)
    });
  }
  if (orderTypesAvailable.isCateringAvailable) {
    options.push({
      label: t(
        "settingsModule.registerModeSettings.general.orderTypes.catering"
      ),
      value: PRINTER_RULES_ORDER_TYPE_OPTIONS.indexOf("catering" /* CATERING */)
    });
  }
  if (orderTypesAvailable.isDeliveryAvailable) {
    options.push({
      label: t(
        "settingsModule.registerModeSettings.general.orderTypes.delivery"
      ),
      value: PRINTER_RULES_ORDER_TYPE_OPTIONS.indexOf("delivery" /* DELIVERY */)
    });
  }
  if (orderTypesAvailable.isToGoAvailable) {
    options.push({
      label: t("settingsModule.registerModeSettings.general.orderTypes.toGo"),
      value: PRINTER_RULES_ORDER_TYPE_OPTIONS.indexOf("to_go" /* TO_GO */)
    });
  }
  return [options];
};
var abbreviateDays = (t, days) => {
  const abbreviatedDays = [];
  if (days === null)
    return t("settingsModule.printerRulesSettings.abbreviatedDays.noSelected");
  if (days === "monday,tuesday,wednesday,thursday,friday,saturday,sunday")
    return t("settingsModule.printerRulesSettings.abbreviatedDays.all");
  const dayAbbreviations = {
    monday: t("settingsModule.printerRulesSettings.abbreviatedDays.monday"),
    tuesday: t("settingsModule.printerRulesSettings.abbreviatedDays.tuesday"),
    wednesday: t(
      "settingsModule.printerRulesSettings.abbreviatedDays.wednesday"
    ),
    thursday: t("settingsModule.printerRulesSettings.abbreviatedDays.thursday"),
    friday: t("settingsModule.printerRulesSettings.abbreviatedDays.friday"),
    saturday: t("settingsModule.printerRulesSettings.abbreviatedDays.saturday"),
    sunday: t("settingsModule.printerRulesSettings.abbreviatedDays.sunday")
  };
  days.split(",").forEach((day) => {
    if (day in dayAbbreviations) {
      abbreviatedDays.push(dayAbbreviations[day]);
    }
  });
  return abbreviatedDays.join(", ");
};
var selectedDaysOfWeekFactory = (selectedDays) => {
  const days = selectedDays !== null ? selectedDays.split(",") : [];
  const selectedDaysOfWeek = {
    monday: days.includes("monday" /* MONDAY */),
    tuesday: days.includes("tuesday" /* TUESDAY */),
    wednesday: days.includes("wednesday" /* WEDNESDAY */),
    thursday: days.includes("thursday" /* THURSDAY */),
    friday: days.includes("friday" /* FRIDAY */),
    saturday: days.includes("saturday" /* SATURDAY */),
    sunday: days.includes("sunday" /* SUNDAY */)
  };
  return selectedDaysOfWeek;
};
var timeOptionsFactory = ({
  startHour,
  startMinute,
  endHour,
  endMinute,
  showLast
}) => {
  const start = /* @__PURE__ */ new Date();
  start.setHours(startHour, startMinute, 0);
  const end = /* @__PURE__ */ new Date();
  end.setHours(endHour, endMinute, 0);
  const options = [];
  while (start <= end) {
    options.push({
      label: start.toLocaleString("en-US", {
        hour: "2-digit",
        minute: "2-digit"
      }),
      value: options.length + 1
    });
    start.setMinutes(start.getMinutes() + 30);
  }
  if (showLast) {
    options.push({ label: "11:59 PM", value: options.length + 1 });
  }
  return [options];
};
var timeDropdownOptionsFactory = (currentField, selectedInOtherColumn, state) => {
  let startTime = [0, 0];
  let endTime = [23, 59];
  if (selectedInOtherColumn && currentField === "startTime") {
    const [hour, minute] = convert12hTo24hTime(
      getTimeFromUTCCore(selectedInOtherColumn, state, false, false)
    ).split(":");
    endTime = [Number(hour), Number(minute)];
  }
  if (selectedInOtherColumn && currentField === "endTime") {
    const [hour, minute] = convert12hTo24hTime(
      getTimeFromUTCCore(selectedInOtherColumn, state, false, false)
    ).split(":");
    startTime = [Number(hour), Number(minute)];
  }
  let timeOptions = [[]];
  if (currentField === "startTime") {
    timeOptions = timeOptionsFactory({
      startHour: 0,
      startMinute: 0,
      endHour: endTime[0],
      endMinute: endTime[1] === 59 ? endTime[1] - 29 : endTime[1] - 30,
      showLast: false
    });
  }
  if (currentField === "endTime") {
    timeOptions = timeOptionsFactory({
      startHour: startTime[0],
      startMinute: startTime[1] + 30,
      endHour: 23,
      endMinute: 59,
      showLast: true
    });
  }
  return timeOptions;
};

export { DEFAULT_SERVICE_AREA_OPTIONS, PRINTER_RULES_ORDER_TYPE_OPTIONS, abbreviateDays, orderTypeDropdownOptionsFactory, selectedDaysOfWeekFactory, serviceAreasDropdownOptionsFactory, timeDropdownOptionsFactory, timeOptionsFactory };
